export default __webpack_public_path__ + "static/media/web_screen_meetings_it.5214298b.png";